import React, { useState } from 'react';
import { TAG_COLORS } from '../config';

const FILTERS = [
  { id: 'all', label: 'Todos' },
  { id: 'unread', label: 'Não lidos' },
  { id: 'bot', label: 'Com bot' },
  { id: 'perpetue', label: 'Perpetue' },
  { id: 'ioa', label: 'IOA' },
];

const CHANNEL_ICON = { whatsapp: '📱', instagram: '📸', facebook: '👍' };

export default function ContactList({ contacts, activeId, onSelect, companies }) {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');

  const filtered = contacts.filter(c => {
    const matchSearch = !search ||
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.phone.includes(search);
    const matchFilter =
      filter === 'all' ? true :
      filter === 'unread' ? c.unread > 0 :
      filter === 'bot' ? c.agentActive :
      c.company === filter;
    return matchSearch && matchFilter;
  });

  // Group by company
  const grouped = {};
  filtered.forEach(c => {
    if (!grouped[c.company]) grouped[c.company] = [];
    grouped[c.company].push(c);
  });

  const s = {
    panel: {
      width: 280,
      background: '#1c1c1f',
      borderRight: '1px solid #27272a',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    header: {
      padding: '14px 14px 10px',
      borderBottom: '1px solid #27272a',
    },
    title: { fontSize: 14, fontWeight: 600, color: '#e4e4e7', marginBottom: 10 },
    search: {
      width: '100%',
      padding: '7px 10px',
      background: '#27272a',
      border: '1px solid #3f3f46',
      borderRadius: 8,
      color: '#e4e4e7',
      fontSize: 13,
      outline: 'none',
    },
    filtersRow: {
      display: 'flex',
      gap: 5,
      padding: '8px 14px',
      borderBottom: '1px solid #27272a',
      overflowX: 'auto',
    },
    chip: (active) => ({
      padding: '3px 9px',
      borderRadius: 20,
      fontSize: 11,
      fontWeight: 500,
      border: `1px solid ${active ? '#6366f1' : '#3f3f46'}`,
      background: active ? '#6366f1' : 'transparent',
      color: active ? '#fff' : '#a1a1aa',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    }),
    list: { flex: 1, overflowY: 'auto' },
    groupLabel: {
      padding: '8px 14px 4px',
      fontSize: 10,
      fontWeight: 600,
      color: '#52525b',
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
    },
    item: (isActive) => ({
      padding: '10px 14px',
      display: 'flex',
      gap: 10,
      cursor: 'pointer',
      background: isActive ? 'rgba(99,102,241,0.12)' : 'transparent',
      borderLeft: `3px solid ${isActive ? '#6366f1' : 'transparent'}`,
      borderBottom: '1px solid #27272a',
      transition: 'background 0.1s',
    }),
    avatar: (color) => ({
      width: 38, height: 38,
      borderRadius: '50%',
      background: color + '33',
      color: color,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 13, fontWeight: 600,
      flexShrink: 0,
      position: 'relative',
    }),
    info: { flex: 1, minWidth: 0 },
    nameRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 2,
    },
    name: { fontSize: 13, fontWeight: 500, color: '#e4e4e7' },
    time: { fontSize: 10, color: '#52525b' },
    preview: {
      fontSize: 12,
      color: '#71717a',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'flex',
      alignItems: 'center',
      gap: 4,
    },
    tagsRow: { display: 'flex', gap: 3, marginTop: 4, flexWrap: 'wrap' },
    tag: (t) => ({
      padding: '1px 5px',
      borderRadius: 3,
      fontSize: 9,
      fontWeight: 600,
      background: TAG_COLORS[t]?.bg || '#27272a',
      color: TAG_COLORS[t]?.text || '#a1a1aa',
    }),
    unreadBadge: {
      width: 18, height: 18,
      background: '#6366f1',
      borderRadius: '50%',
      fontSize: 10,
      fontWeight: 700,
      color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0,
    },
  };

  const companyColors = {};
  companies.forEach(c => { companyColors[c.id] = c.color; });

  const getInitials = name => name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div style={s.panel}>
      <div style={s.header}>
        <div style={s.title}>Conversas</div>
        <input
          style={s.search}
          placeholder="Buscar..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div style={s.filtersRow}>
        {FILTERS.map(f => (
          <button key={f.id} style={s.chip(filter === f.id)} onClick={() => setFilter(f.id)}>
            {f.label}
          </button>
        ))}
      </div>

      <div style={s.list}>
        {Object.entries(grouped).map(([companyId, items]) => {
          const company = companies.find(c => c.id === companyId);
          return (
            <div key={companyId}>
              <div style={s.groupLabel}>{company?.name || companyId}</div>
              {items.map(contact => (
                <div
                  key={contact.id}
                  style={s.item(contact.id === activeId)}
                  onClick={() => onSelect(contact.id)}
                >
                  <div style={s.avatar(companyColors[contact.company] || '#6366f1')}>
                    {getInitials(contact.name)}
                    <span style={{ position: 'absolute', bottom: -1, right: -1, fontSize: 10 }}>
                      {CHANNEL_ICON[contact.channel] || '📱'}
                    </span>
                  </div>
                  <div style={s.info}>
                    <div style={s.nameRow}>
                      <span style={s.name}>{contact.name}</span>
                      <span style={s.time}>{contact.lastTime}</span>
                    </div>
                    <div style={s.preview}>
                      {contact.agentActive && <span title="Bot ativo">🤖</span>}
                      <span>{contact.lastMsg}</span>
                      {contact.unread > 0 && (
                        <span style={{ ...s.unreadBadge, marginLeft: 'auto' }}>
                          {contact.unread}
                        </span>
                      )}
                    </div>
                    <div style={s.tagsRow}>
                      {contact.tags.map(t => (
                        <span key={t} style={s.tag(t)}>{t}</span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
        {filtered.length === 0 && (
          <div style={{ padding: 24, textAlign: 'center', color: '#52525b', fontSize: 13 }}>
            Nenhuma conversa encontrada
          </div>
        )}
      </div>
    </div>
  );
}
